// noinspection JSUnresolvedReference

import playLiveOpenGraph from "@/assets/playlive-og-image-preview.jpg";
import { getAssetImageUrl } from "@/util/common.js";

export const isTestMode = import.meta.env.VITE_APP_ENV === "test";
export const isDevMode = import.meta.env.VITE_APP_ENV === "dev";

// biome-ignore lint/correctness/noUndeclaredVariables: This is injected at build time
export const overlayIconReplacePath = __OVERLAY_ICON_REPLACE_PATH__;

export const isTwitchEnabled =
  !import.meta.env.VITE_TWITCH_DISABLED || import.meta.env.VITE_TWITCH_DISABLED !== "true";

export const CHARITY = {
  TILTIFY: "tiltify",
  TWITCH: "twitch",
};

export const siteDescription = isTestMode
  ? `Keep everyone up-to-date on your fundraising progress, use themed graphics on your stream, connect with chat through new interactive chatbot commands, and easily share facts.`
  : `Keep everyone up-to-date on your fundraising progress, use themed graphics on your stream, connect with chat through new interactive chatbot commands, and easily share facts about the life-saving mission of St. Jude Children's Research Hospital.`;

export const defaultOpenGraphImage = getAssetImageUrl(playLiveOpenGraph);
